const Testimonials = () => {
  return (
    <div className="Pages">
    <h1>Testimonials</h1>
  </div>
  );
};

export default Testimonials;
